var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAngleDown = function SvgAngleDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.434 8.151c.198-.198.297-.297.411-.334a.5.5 0 0 1 .31 0c.114.037.213.136.41.334L12 13.586l5.434-5.435c.198-.198.297-.297.412-.334a.5.5 0 0 1 .308 0c.115.037.214.136.412.334l.283.283c.198.198.296.297.334.411.032.1.032.21 0 .31-.038.114-.136.213-.334.41l-6.283 6.284c-.198.198-.297.296-.412.334a.5.5 0 0 1-.309 0c-.114-.038-.213-.136-.41-.335L5.15 9.567c-.198-.198-.297-.297-.334-.411a.5.5 0 0 1 0-.31c.037-.114.136-.213.334-.41z",
    clipRule: "evenodd"
  })));
};
export default SvgAngleDown;